export default __webpack_public_path__ + "static/media/user_icon.63e8d0eb.svg";